import { getValidationMessage } from "../../utils/i18nHelper";
import { validationMessages } from "./tracksOptions";

export const getArtistNameValidators = (lang) => {
  let artistNameValidators = {
    validators: {
      notEmpty: {
        message: getValidationMessage(validationMessages, 'artistName', 'required', lang)
      },
    }
  };
  return artistNameValidators;
};


export const getArtistTypeValidators = (lang) => {
    let artistTypeValidators = {
      validators: {
        notEmpty: {
          message: getValidationMessage(validationMessages, 'artistType', 'required', lang)
        },
      }
    };
    return artistTypeValidators;
};

export const getPublisherNameValidators = (lang) => {
  let publisherNameValidators = {
    validators: {
      notEmpty: {
        message: getValidationMessage(validationMessages, 'publisherName', 'required', lang)
      },
    }
  };
  return publisherNameValidators;
};

export const getPublisherAuthorValidators = (lang) => {
  let publisherAuthorValidators = {
    validators: {
      notEmpty: {
        message: getValidationMessage(validationMessages, 'publisherAuthor', 'required', lang)
      },
    }
  };
  return publisherAuthorValidators;
};

export const getContributorNameValidators = (lang) => {
  let contributorNameValidators = {
    validators: {
      notEmpty: {
        message: getValidationMessage(validationMessages, 'contributorName', 'required', lang)
      },
    }
  };
  return contributorNameValidators;
};

export const getContributorRoleValidators = (lang) => {
  let contributorRoleValidators = {
    validators: {
      notEmpty: {
        message: getValidationMessage(validationMessages, 'contributorRole', 'required', lang)
      },
    }
  };
  return contributorRoleValidators;
};

export const getShareholderNameValidators = (lang) => {
  let shareholderNameValidators = {
    validators: {
      notEmpty: {
        message: getValidationMessage(validationMessages, 'shareholderName', 'required', lang)
      },
    }
  }
  return shareholderNameValidators;
};

export const getCostTypeValidators = (lang) => {
  let costTypeValidators = {
    validators: {
      notEmpty: {
        message: getValidationMessage(validationMessages, 'costType', 'required', lang)
      },
    }
  }
  return costTypeValidators;
};
